import domain from './domain';

// Reset core user 
export const resetCoreUser = domain.createEvent('resetCoreUser');

// Reset core user occupancy
export const resetCoreUserOccupancy = domain.createEvent('resetCoreUserOccupancy');

